/* ============================================================
   Регламенты и документы + примечание.
   ============================================================ */
import { useFedStore, useL } from '../store';
import { useFedContent, uploadUrl } from '../content';
import { Ic } from '../icons';
import { Rv, Eyebrow } from '../ui';

export default function FedRegulations() {
  const { lang } = useFedStore();
  const L = useL();
  const docs = useFedContent((s) => s.docs);

  return (
    <div className="fed-pagewrap max-w-[960px] mx-auto" style={{ padding: '52px 24px 72px' }}>
      <Rv style={{ marginBottom: 30 }}>
        <Eyebrow style={{ marginBottom: 12 }}>{L.nav_regs}</Eyebrow>
        <h1 style={{ fontSize: 'clamp(36px,5.5vw,58px)' }}>{L.reg_h1}</h1>
        <p className="max-w-[580px] text-fg-soft" style={{ marginTop: 14, fontSize: 16, lineHeight: 1.6 }}>{L.reg_sub}</p>
      </Rv>

      {!docs.length && (
        <Rv className="flex items-center gap-4 rounded-[14px] border border-line text-fg-muted" style={{ padding: '26px 22px', background: 'linear-gradient(160deg,var(--fed-surface-2),var(--fed-surface))', fontSize: 15 }}>
          <Ic name="doc" size={22} color="var(--fed-fg-faint)" />
          {L.reg_empty}
        </Rv>
      )}

      <div className="flex flex-col gap-3">
        {docs.map((d) => (
          <Rv
            key={d.id || d.name_ru}
            as="a"
            href={uploadUrl(d.file) || undefined}
            target="_blank"
            rel="noopener noreferrer"
            className="fed-hover-lift flex items-center gap-4 rounded-[14px] border border-line no-underline"
            style={{ padding: '18px 20px', background: 'linear-gradient(160deg,var(--fed-surface-2),var(--fed-surface))' }}
          >
            <span className="flex-shrink-0 flex items-center justify-center rounded-xl text-accent-bright" style={{ width: 48, height: 48, background: 'rgba(225,18,23,.09)', border: '1px solid var(--fed-line-accent)' }}>
              <Ic name="doc" size={20} />
            </span>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-fg" style={{ fontSize: 15.5 }}>{d['name_' + lang]}</div>
              <div className="font-mono text-fg-faint" style={{ fontSize: 11, marginTop: 3 }}>{d.size}</div>
            </div>
            <span className="inline-flex items-center gap-[7px] font-display font-semibold uppercase text-accent-bright" style={{ fontSize: 13, letterSpacing: '.03em' }}>
              <Ic name="download" size={16} sw={1.9} />
              {L.ab_download}
            </span>
          </Rv>
        ))}
      </div>

      <Rv className="flex gap-3 items-start rounded-[14px]" style={{ marginTop: 22, padding: '18px 20px', background: 'rgba(230,183,60,.06)', border: '1px solid rgba(230,183,60,.3)' }}>
        <span className="text-gold flex-shrink-0" style={{ marginTop: 1 }}>
          <Ic name="info" size={18} sw={1.8} />
        </span>
        <p className="text-fg-muted" style={{ fontSize: 13.5, lineHeight: 1.6 }}>{L.reg_note}</p>
      </Rv>
    </div>
  );
}
